import Error from '@common/components/Error';
import { Label } from '@common/components/Typography';
import React, { FC } from 'react';
import asReduxFormField from '../asReduxFormField';
import AssistiveText from '../styled/AssistiveText';
import InputWrapper from '../styled/FieldWrapper';
import StyledInput from '../styled/StyledInput';
import { FieldBlock } from './BlockInputField.styles';

export type BlockInputFieldProps = {
  isRequired?: boolean;
  label?: string | JSX.Element;
  error?: string | JSX.Element | {};
  assistiveText?: string | JSX.Element;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  noAssistive?: boolean;
  placeholder?: string;
  innerRef?: object;
  id?: string;
  name?: string;
  onClick?: () => void;
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const BlockInputField: FC<BlockInputFieldProps> = ({
  isRequired = false,
  label,
  error,
  value = '',
  onChange = () => {},
  disabled = false,
  assistiveText,
  noAssistive = false,
  innerRef,
  id,
  onClick,
  ...props
}) => {
  const parsedValue = value || '';
  return (
    <FieldBlock noAssistive={noAssistive} onClick={onClick}>
      <InputWrapper>
        {label && (
          <Label error={error} isRequired={isRequired} htmlFor={id}>
            {label}
          </Label>
        )}
        <StyledInput
          {...props}
          disabled={disabled}
          error={error}
          onChange={onChange}
          value={parsedValue}
          ref={innerRef}
          id={id}
        />
      </InputWrapper>
      {(error || assistiveText) && (
        <AssistiveText data-testid={`error-text-${label}`}>
          {error ? <Error error={error} /> : assistiveText}
        </AssistiveText>
      )}
    </FieldBlock>
  );
};

export const ReduxFormInput = asReduxFormField(BlockInputField);
